import ValidateMixin from '@/app/shared/mixins/ValidateMixin';
import { formatUrl } from "@config/utils";

export default {
    mixins: [
        ValidateMixin,
    ],
    components: {
    },
    inject: {
        parentValidator: 'parentValidator',
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        idPanel: {
            type: String,
            require: true,
        },
        idSubPanel: {
            type: String,
            default: '',
        },
        panelCfg: {
            type: Object,
            default: () => {},
        },
        baseTranslateID: {
            type: String,
        },
        vScope: {
            type: String,
            default: 'form',
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        resources: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {

        }
    },
    created: function () {
        this.$validator = this.parentValidator;
    },
    computed: {
        url() {
            return this.panelCfg?.url ?? {};
        },
        modelTranslateID() {
            return this.idSubPanel ? `${this.baseTranslateID}.model.${this.idSubPanel}` : `${this.baseTranslateID}.model`;
        },
        formTranslateID() {
            return this.idSubPanel ? `${this.baseTranslateID}.form.${this.idSubPanel}` : `${this.baseTranslateID}.form`;
        },
        helpTranslateID() {
            return this.idSubPanel ? `${this.baseTranslateID}.help.${this.idSubPanel}` : `${this.baseTranslateID}.help`;
        },
        hasResources() {
            return this.resources && this.resources.length > 0;
        },
        selectedResource() {
            if(this.hasResources) {
                return this.resources[0];
            }
            return null;
        },
    },
    methods: {
        async loadDescribeResource() {
            if(this.selectedResource) {
                let url = this.url.describeResource
                if(url) {
                    return await this.$http.get(formatUrl(url, {id: this.selectedResource?.id}))
                    .then( res => {
                        return res.data?.data ?? res?.data ?? res;
                    })
                    .catch( error => {
                        this.showHttpError(error);
                        return null;
                    })
                }
            }
            return Promise.resolve(null);
        },
        forceDirtyUpload: function(key){
            if(this.fields.$form && this.fields.$form[key]){
                this.fields.$form[key].dirty=true;
            }
        },
    }
};
